<template>
  <div class="md:py-8">
    <template v-if="productDetails">
      <!-- Ürün Detay Bölümü -->
      <div class="max-w-7xl mx-auto md:px-6 lg:px-8">
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <!-- Sol Taraf - Ürün Görselleri -->
          <div class="relative">
            <FrontendProductGallery v-if="productDetails.product_images?.length" :images="productDetails.product_images"
              class="sticky top-4" />
          </div>

          <!-- Sağ Taraf - Ürün Bilgileri -->
          <div class="space-y-6">
            <!-- Ürün Başlığı -->
            <div class="space-y-1.5 px-4 sm:px-6 md:px-0">
              <h1 class="!mt-0 text-xl md:text-2xl text-gray-900 font-medium leading-relaxed">
                <b>{{ productDetails.brand_name }}</b>
                {{ productDetails.name }}
              </h1>
            </div>

            <FrontendProductBuyBox :product-id="productDetails.id" :product-url="productUrl" />

            <!-- Öne Çıkan Özellikler (Özet) -->
            <UCard v-if="productDetails.featured_infos?.length" color="gray" variant="soft" class="mt-6"
              :ui="{ rounded: 'rounded-none md:rounded-lg' }">
              <ul class="space-y-3">
                <li v-for="info in productDetails.featured_infos.slice(0, 3)" :key="info.id"
                  class="flex items-start gap-3">
                  <UBadge color="orange" variant="soft"
                    class="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center">
                    <UIcon name="i-heroicons-check" class="w-4 h-4" />
                  </UBadge>
                  <p class="text-sm text-gray-600 leading-relaxed">
                    {{ info.content }}
                  </p>
                </li>
              </ul>
              <UButton v-if="productDetails.featured_infos.length > 3" @click="scrollToFeatures" color="orange"
                variant="ghost" class="mt-4 w-full">
                <template #leading> Tüm bilgileri gör </template>
                <template #trailing>
                  <UIcon name="i-heroicons-arrow-long-down" />
                </template>
              </UButton>
            </UCard>
          </div>
        </div>
      </div>

      <!-- Detaylı Özellikler ve Açıklama -->
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 space-y-6">
        <!-- Ürün Özellikleri -->
        <UCard class="mt-6" :ui="{ rounded: 'rounded-none md:rounded-lg' }">
          <template #header>
            <h2 class="text-xl font-semibold">Ürün Özellikleri</h2>
          </template>
          <FrontendProductSpecifications v-if="productDetails.id" :product-id="productDetails.id" />
        </UCard>

        <!-- Ürün Açıklaması -->
        <UCard v-if="productDetails.additional_info" class="mt-8" :ui="{ rounded: 'rounded-none md:rounded-lg' }">
          <template #header>
            <h2 class="text-xl font-semibold">Ürün Açıklaması</h2>
          </template>
          <div class="prose prose-sm max-w-none">
            <div v-html="productDetails.additional_info" class="text-gray-700"></div>
          </div>
        </UCard>

        <!-- Öne Çıkan Özellikler (Detaylı) -->
        <UCard v-if="productDetails.featured_infos?.length" id="featured-details" class="mt-8 scroll-mt-6"
          :ui="{ rounded: 'rounded-none md:rounded-lg' }">
          <template #header>
            <h2 class="text-xl font-semibold">Öne Çıkan Özellikler</h2>
          </template>
          <div class="grid gap-4 sm:grid-cols-2">
            <div v-for="info in productDetails.featured_infos" :key="info.id" class="flex items-start gap-3">
              <UBadge color="orange" variant="soft"
                class="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center">
                <UIcon name="i-heroicons-check" class="w-4 h-4" />
              </UBadge>
              <p class="text-sm text-gray-600 leading-relaxed">
                {{ info.content }}
              </p>
            </div>
          </div>
        </UCard>
      </div>
    </template>
<br>
    <FrontendProductCarouselPlacementSection
      v-if="productDetails?.category_id"
      placement="product-1"
      :category-id="productDetails.category_id"
      @add-to-cart="handleAddToCart"
      @toggle-favorite="handleToggleFavorite"
    />
  </div>
</template>

<script setup>
const route = useRoute()
const productDetailsStore = useProductDetailsStore()
const productUrl = 'urun/' + route.params.brand + '/' + route.params.slug

const { API_ENDPOINTS } = useApiEndpoints()

const { data: productDetailsData } = await useAsyncData('product-details', async () => {
  const response = await useBaseOFetchWithAuth(
    API_ENDPOINTS.public.products.details(productUrl)
  )
  return response.data
})

// Store'a veriyi set et
if (productDetailsData.value) {
  productDetailsStore.productDetails = productDetailsData.value
}

// Details verisi için computed
const productDetails = computed(() => productDetailsStore.getProductDetails)

const handleAddToCart = (productData) => {
  console.log('Sepete eklendi:', productData)
}

const handleToggleFavorite = (product) => {
  console.log('Favorilere eklendi:', product)
}

// Özellikler bölümüne yumuşak kaydırma
const scrollToFeatures = () => {
  nextTick(() => {
    const element = document.getElementById('featured-details')
    if (element) {
      const headerOffset = 80 // Sabit header varsa onun yüksekliği
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
    }
  })
}

await useSiteMeta()
const siteSettings = useSiteSettingsStore()
const { title: siteTitle } = storeToRefs(siteSettings)
useHead({
  title: `${productDetails.value?.name} - ${siteTitle.value}`,
  meta: [
    {
      name: 'description',
      content: productDetails.value?.shortDescription || `${productDetails.value?.name} - En uygun fiyat ve hızlı kargo seçenekleriyle Binaffan'da!`
    }
  ]
})
</script>
